import React, { useState } from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import GetName from 'utils/getName';
import getSi from 'utils/getSi';
import nextIssue from 'utils/nextIssue';
import updateHealthIssuesAnswers from 'utils/updateHealthIssuesAnswers';
import updateQuizInfo, { getQuizInfo } from 'utils/updateQuizInfo';
import DotDetails from '../DotDetails/DotDetails';
import DotSelector from '../DotSelector/DotSelector';

import QuizSlideNavigation from '../QuizSlideNavigation/QuizSlideNavigation';
import QuizSlideHeading from '../QuizSlideHeading/QuizSlideHeading';

const QuizDermatologyFour = () => {
  const navigate = useNavigate();
  const si = getSi();

  const [name, setName] = useState('');
  const contextName = useSelector((state) => state.quiz.name);
  const dispatch = useDispatch();

  useEffect(() => {
    const dogName = async () => {
      if (contextName) {
        setName(contextName);
      } else {
        const n = await GetName(si, dispatch);
        setName(n);
      }
    };
    dogName();
  }, [si]);

  useEffect(() => {
    const info = getQuizInfo();
    if (info?.dermatology_q4) {
      setOption(info.dermatology_q4);
    }
  }, []);

  useEffect(() => {
    if (si) {
      updateQuizInfo({ slide: 'dermatology-4' });
    } 
  }, [si]);

  const [option, setOption] = useState(1);
  const dotSelectorData = [{ name: 1 }, { name: 2 }, { name: 3 }];
  const handleClick = () => {
    if (option) {
      updateQuizInfo({ dermatology_q4: option });
      updateHealthIssuesAnswers({ dermatology_q4: option });
      nextIssue(navigate);
    }
  };

  const dotDetailsData = [
    {
      title: 'Not at all',
      body: 'My dog has had their anal glands expressed less than twice',
    },
    {
      title: 'Somewhat',
      body: 'My dog has been to the vet several times for anal gland expression',
    },
    {
      title: 'Significantly',
      body: 'My dog has their anal glands expressed every 3 months or more',
    },
  ];
  return (
    <section className="min-h-screen bg-dteal-50 pt-24 md:pt-4">
      <div className="container mx-auto flex h-screen flex-col items-center justify-center gap-12">
        <QuizSlideHeading
          before={`Does ${name}`}
          title="Need to have their anal glands expressed?"
        />

        <div>
          <DotSelector
            data={dotSelectorData}
            option={option}
            details={dotDetailsData}
            setOption={setOption}
          />
          <DotDetails details={dotDetailsData} />
        </div>
        <QuizSlideNavigation handleBack={()=>navigate(-1)}  handleNext={handleClick} />
      </div>
    </section>
  );
};

export default QuizDermatologyFour;
